import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import FieldButton from '../../../FieldButton'
import { Duplicate2 } from 'wix-style-react/dist/src/Icons'
import Text from 'components/common/Text'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 65px;
  margin-top: 15px;
`
const ResetTextContainer = styled.div`
  cursor: pointer;
`

class SPPositionZoomAll extends Component {

  onChange = () => { this.props.onChange({}) }

  render () {
    if (this.props.isFieldButton) {
      return (
        <FieldButton
          className='js-field-button'
          clickHandler={this.onChange}
          icon={<Duplicate2 size='1em' />}
          label='Make all logos the same position and size as this one'
        />
      )
    } else {
      return (
        <Container>
          <ResetTextContainer onClick={this.onChange}>
            <Text>{this.props.title}</Text>
          </ResetTextContainer>
        </Container>
      )
    }
  }
}

SPPositionZoomAll.defaultProps = {
  onChange: () => null,
  title: '',
  isFieldButton: false
}

SPPositionZoomAll.propTypes = {
  title: PropTypes.string,
  onChange: PropTypes.func,
  isFieldButton: PropTypes.bool
}

export default SPPositionZoomAll



// WEBPACK FOOTER //
// ./src/components/editor/popovers/customCSS/stylePresetComponents/SPPositionZoomAll.js